import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import $ from "jquery";
import moment from "moment";
import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { FormattedMessage } from 'react-intl';
import ActionButton from "../common/button/actionbutton.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import { GlobalHelper } from "../indexImports.js";
const uuidv4 = require('uuid/v4')

class NewAccountStatementModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId || 'account-statement-modal-' + uuidv4(),
            date: moment(),
            contactId: this.props.contactId || '',
            redirect: '',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
        })
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    closeModal(res) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(res)
        }
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    submit(e) {
        e.preventDefault()
        AppContext.getApiClient().post('/account-statements', {
            date: this.state.date,
            contactId: this.state.contactId,
            type: 'open-item',
        }).then(res => {
            const accountStatementId = res.id
            if (!res.error) {
                AppContext.getApiClient().post('/proposals', {
                    accountStatementId: res.id,
                    contactId: this.state.contactId,
                    hash: res.attributes.hash,
                }).then(res => {
                    if (GlobalHelper.shouldEnforceEnvFlag()) {
                        this.closeModal(res)
                    } else {
                        this.closeModal(accountStatementId)
                    }
                })

            }
        })
    }

    render() {
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="emailModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            {this.state.redirect}
            <div className="modal-dialog modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="emailModalTitle">
                            <Icon value={'file-invoice'} className={'mr-2'} />
                            <FormattedMessage
                                id="invoice.account_statement_modal.title"
                                defaultMessage="Create account statement"
                            />
                        </h5>
                        <button type="button" className="close" onClick={e => {
                            e.preventDefault()
                            this.closeModal()
                        }} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ overflow: 'visible' }}>
                        <div className="container-fluid">
                            <div className="form-group row mb-3">
                                <label className="col-12 col-md-4  col-form-label custom-form-label pb-2" htmlFor="date">
                                    <FormattedMessage
                                        id="invoice.account_statement_modal.statement_date_label"
                                        defaultMessage="Statement date"
                                    />
                                </label>
                                <div className="col-12 col-md-8">
                                    <SingleDatePicker
                                        small
                                        block
                                        displayFormat="LL"
                                        focused={this.state.focused}
                                        isOutsideRange={() => false}
                                        onDateChange={(date) => {
                                            this.setState({
                                                date: date
                                            })
                                        }}
                                        onFocusChange={({ focused }) => this.setState({ focused })}
                                        date={this.state.date}
                                        numberOfMonths={1}
                                        id={'date'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-end">
                        <div>
                            <button type="button" className="btn btn-secondary mr-2" onClick={e => {
                                e.preventDefault()
                                this.closeModal()
                            }}>
                                <FormattedMessage
                                    id="invoice.account_statement_modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                            <ActionButton
                                type="button"
                                className="btn btn-primary"
                                onClick={this.submit}
                            >
                                <FormattedMessage
                                    id="invoice.account_statement_modal.save_btn"
                                    defaultMessage="Create a new statement"
                                />
                            </ActionButton>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    }
}

export default NewAccountStatementModal



// WEBPACK FOOTER //
// ./src/customer/accountstatementmodal.component.jsx